import Tooltip from 'antd/es/tooltip';
import React, {useState, useEffect} from 'react';

const ExamsSharedAndAssignedTask = ({
  sharedBy = '',
  isSharedActive = true,
  isAssignedActive = true,
  isUnitExam = false,
  styles
}) => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const imgRight = isSharedActive
    ? windowWidth <= 420
      ? '120px'
      : '162px'
    : '';

  const textRight = isSharedActive
    ? windowWidth <= 420
      ? '199px'
      : '229px'
    : '';


  return (
    <div className="cardAssignInfo">


    <div className='cardlabelSet' style={{ 
            color: isUnitExam ? '#43969C' : 'white'
          }}>
      {isUnitExam ? <span className="assignmentLabel" >EXAMEN DE UNIDAD</span> : <span className="assignmentLabel" >PRUEBA</span>}
    </div>


      {isSharedActive && (
        <>
          <Tooltip
            title={`Shared by ${sharedBy}`}
            placement='top'
            showArrow={false}>
           <p className="sharedInfo">Shared by {sharedBy?.length > 8 ? sharedBy.slice(0, 0) + '...' : sharedBy}</p>
          </Tooltip>
        </>
      )}
      {isAssignedActive && (
        <>
          <p className="assignInfo">
            Assigned
          </p>
        </>
      )}
    </div>
  );
};

const ExamenImage = ({color = "#012D75", className =""}) => {
  return (
    <svg
      width="127"
      height="36"
      viewBox="0 0 127 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className = {className}
    >
      <path
        id="Vector"
        d="M127.025 0V35.2801C127.025 29.6445 122.437 25.0996 116.804 25.0996H0V18.749C0 8.39887 8.43265 0 18.8244 0H127.037H127.025Z"
        fill={color}
      />
    </svg>
  );
};

export default ExamsSharedAndAssignedTask;
